export default "__VITE_ASSET__C_QK55p$__"